<template>
  <div>
    <form role="form">
      <div class="box-body">
        <div class="form-group">
          <label for="name">Nome</label>
          <input type="text" class="form-control" id="name" placeholder="Entre com o nome do parque" v-model="park.name">
          <p v-if="errors.name" class="text-red">{{ errors.name }}</p>
        </div>
        <div class="form-group">
          <label for="initials">Sigla</label>
          <input type="text" class="form-control" id="initials" placeholder="Entre com a sigla do parque" v-model="park.initials">
          <p v-if="errors.initials" class="text-red">{{ errors.initials }}</p>
        </div>
        <div class="form-group">
          <label for="cnpj">Cnpj</label>
          <the-mask
          :mask="['##.###.###/####-##']"
          id="cnpj"
          type="text"
          :masked="true"
          placeholder="Entre com o Cnpj"
          class="form-control"
          v-model="park.cnpj"
          />
          <p v-if="errors.cnpj" class="text-red">{{ errors.cnpj }}</p>
        </div>
        <div class="form-group">
          <label for="legalResponsible">Responsável Legal</label>
          <input type="text" class="form-control" id="legalResponsible" placeholder="Entre com o nome do responsável legal" v-model="park.legalResponsible">
          <p v-if="errors.legalResponsible" class="text-red">{{ errors.legalResponsible }}</p>
        </div>
        <div class="form-group">
          <label for="website">Website</label>
          <input type="text" class="form-control" id="website" placeholder="Entre com o website" v-model="park.website">
          <p v-if="errors.website" class="text-red">{{ errors.website }}</p>
        </div>
        <div class="form-group">
          <label for="instagram">Instagram</label>
          <input type="text" class="form-control" id="instagram" placeholder="Entre com o Instagram" v-model="park.instagram">
          <p v-if="errors.instagram" class="text-red">{{ errors.instagram }}</p>
        </div>
        <div class="form-group">
          <label for="linkedin">Linkedin</label>
          <input type="text" class="form-control" id="linkedin" placeholder="Entre com o Linkedin" v-model="park.linkedin">
          <p v-if="errors.linkedin" class="text-red">{{ errors.linkedin }}</p>
        </div>
        <div class="form-group">
          <label for="currentStage">Estágio em que se encontra o parque tecnológico</label>
          <select class="form-control" id="currentStage" v-model="park.currentStage">
            <option value="" disabled selected>Selecione...</option>
            <option>Planejamento</option>
            <option>Implantação</option>
            <option>Operação</option>
          </select>
          <p v-if="errors.currentStage" class="text-red">{{ errors.currentStage }}</p>
        </div>
        <fieldset>
          <legend>Endereço</legend>
          <div class="form-group">
            <label for="street">Rua</label>
            <input type="text" class="form-control" id="street" placeholder="Entre com a rua" v-model="park.street">
            <p v-if="errors.street" class="text-red">{{ errors.street }}</p>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="neighborhood">Bairro</label>
                <input type="text" class="form-control" id="neighborhood" placeholder="Entre com o bairro" v-model="park.neighborhood">
                <p v-if="errors.neighborhood" class="text-red">{{ errors.neighborhood }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="number">Número</label>
                <input type="number" class="form-control" id="number" placeholder="Entre com o número" v-model="park.number">
                <p v-if="errors.number" class="text-red">{{ errors.number }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="state">Estado</label>
                <model-select
                  :options="states"
                  v-model="park.state"
                  id="state"
                  class="form-control"
                  placeholder="Entre com o estado"
                  :custom-attr="customSelectItemClass"
                />
                <p v-if="errors.state" class="text-red">{{ errors.state }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="city">Cidade</label>
                <model-select
                  :options="cities"
                  v-model="park.city"
                  id="city"
                  class="form-control"
                  placeholder="Entre com a cidade"
                  :custom-attr="customSelectItemClass"
                />
                <p v-if="errors.city" class="text-red">{{ errors.city }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="postalCode">CEP</label>
                <the-mask
                :mask="['#####-###']"
                id="postalCode"
                type="text"
                :masked="true"
                placeholder="Entre com o CEP"
                class="form-control"
                v-model="park.postalCode"
                />
                <p v-if="errors.postalCode" class="text-red">{{ errors.postalCode }}</p>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>Contato</legend>
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" class="form-control" id="email" placeholder="Entre com o email" v-model="park.email">
            <p v-if="errors.email" class="text-red">{{ errors.email }}</p>
          </div>
          <div class="form-group">
            <label for="phoneNumber">Telefone</label>
            <the-mask
            :mask="['(##) ####-####', '(##) #####-####']"
            id="phoneNumber"
            type="text"
            :masked="true"
            placeholder="Entre com o telefone"
            class="form-control"
            v-model="park.phoneNumber"
            />
            <p v-if="errors.phoneNumber" class="text-red">{{ errors.phoneNumber }}</p>
          </div>
        </fieldset>
        <fieldset>
          <legend>Logo</legend>
          <small>Tamanho recomendado: 200x200px</small>
          <div class="text-center">
            <img v-if="this.park['id'] !== undefined" :src="park.logoPicture"/>
          </div>
          <vue-base64-file-upload
          class="text-center"
          accept="image/png,image/jpeg"
          image-class="v1-image"
          input-class="v1-input"
          :max-size="customImageMaxSize"
          :placeholder="'Clique para fazer o upload do logo'"
          :disable-preview="this.park['id'] !== undefined"
          @size-exceeded="onSizeExceeded"
          @load="onLoad" />
        </fieldset>
      </div>
      <div class="box-footer">
        <button type="submit" class="btn btn-sm btn-primary pull-right" v-on:click.prevent="onSubmit">
          <i class="fa fa-save"></i>&nbsp; Salvar
        </button>
        <go-back-button></go-back-button>
      </div>
    </form>
  </div>
</template>

<script>
import TheMask from 'vue-the-mask'
import GoBackButton from '@/components/elements/GoBackButton'
import VueBase64FileUpload from 'vue-base64-file-upload'
import { ModelSelect } from 'vue-search-select'
import brazilCitiesByStateInitials from '../../assets/json/brazil-cities-by-state-initials.json'

export default {
  name: 'ParkForm',
  components: { TheMask, GoBackButton, VueBase64FileUpload, ModelSelect },
  props: ['park', 'errors', 'onSubmit'],
  data () {
    return {
      customImageMaxSize: 3
    }
  },
  mounted () {
    $('#state').attr('autocomplete', 'disable-state-field-autocomplete')
    $('#city').attr('autocomplete', 'disable-city-field-autocomplete')
  },
  computed: {
    states: function () {
      return Object.keys(brazilCitiesByStateInitials).map((e) => ({
        value: e, text: brazilCitiesByStateInitials[e].name
      }))
    },
    cities: function () {
      if (!this.park.state) {
        return []
      }
      const cities = brazilCitiesByStateInitials[this.park.state].cities
      return cities.map((e) => ({value: e, text: e}))
    }
  },
  methods: {
    onLoad (dataUri) {
      this.park.logoPicture = dataUri
    },
    onSizeExceeded (size) {
      alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`)
    },
    customSelectItemClass () {
      return 'search-select-item'
    }
  }
}
</script>

<style>
  .item[data-vss-custom-attr="search-select-item"] {
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// ParkForm.vue?3a39b627